"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    padding: '4px',
    cursor: 'pointer',
    '&.Mui-checked': {
      color: _theme.default.palette.primary.light,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    '&.MuiIconButton-colorSecondary:hover': {
      backgroundColor: 'transparent'
    }
  }
});
var _default = exports.default = useStyles;